import { createStyles } from 'antd-style'

export const useStyle = createStyles(() => ({
  filters: {
    padding: '12px'
  }
}))
